    <template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-card-title color="#f8f9fb" elevation="0">
            <span class="text-h6 font-weight-regular">{{
              $t("modules.title")
            }}</span>
            <v-spacer></v-spacer>
            <v-dialog
              v-model="addModuleDialog"
              max-width="450px"
              @click:outside="closeDialog"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  <v-icon> mdi-plus </v-icon>
                  {{ $t("modules.buttons.add") }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">Add Module</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="module.name"
                          label="Name"
                          name="name"
                          dense
                          v-validate="'required'"
                          :error="
                            errors.first('name') != null ||
                            serverSideErrors.name != null
                          "
                          :error-messages="
                            errors.first('name') || serverSideErrors.name
                          "
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="module.route"
                          label="Route"
                          name="route"
                          dense
                          v-validate="'required'"
                          :error="
                            errors.first('route') != null ||
                            serverSideErrors.route != null
                          "
                          :error-messages="
                            errors.first('route') || serverSideErrors.route
                          "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeModuleDialog">
                    Close
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="saveModule()">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7">
            <v-data-table :headers="headers" :items="modules" :search="search" class="elevation-3">
              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  name="delete_module"
                  title="Delete Module"
                  @click="confirmDelete(item.id)"
                >
                  <v-icon small> mdi-delete-outline </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteModule(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("modules.headers.name")}`,
          value: "name",
          width: "35%",
        },
        {
          text: `${this.$t("modules.headers.route")}`,
          value: "route",
          width: "30%",
        },
        {
          text: `${this.$t("modules.headers.action")}`,
          value: "actions",
          width: "35%",
          sortable: false,
          
        },
      ],
      modules: [],
      addModuleDialog: false,
      module: {
        name: "",
        route: "",
      },
      serverSideErrors: [],
      deleteDialog: false,
      delete_id: "",
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getModules() {
      let _self = this;

      _self.$axios.get("superadmin/modules").then((response) => {
        let data = response.data;

        if (data.status) {
          _self.modules = data.modules;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    closeModuleDialog() {
      this.addModuleDialog = false;
      this.module = {};
      this.$validator.reset();
    },
    saveModule() {
      let _self = this;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$axios
            .post("/superadmin/modules", _self.module)
            .then((response) => {
              let data = response.data;

              if (data.status) {
                // add module to the array
                // this.modules.push(data.module);
                this.getModules();
                this.closeModuleDialog();
              } else {
                if (data.errors) {
                  _self.serverSideErrors = {};

                  for (let i = 0; i < data.errors.length; i++) {
                    _self.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                } else {
                  _self.setAlert({
                    showAlert: true,
                    variant: "red accent-3",
                    timeout: "2000",
                    message: data.message,
                  });
                }
              }
            });
        }
      });
    },
    deleteModule(moduleID) {
      let _self = this;
      _self.$axios
        .delete("superadmin/modules/" + moduleID)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.modules = this.modules.filter((record) => {
              if (record.id != moduleID) {
                return record;
              }
            });
            this.deleteDialog = false;
            this.delete_id = "";
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
            this.deleteDialog = false;
            this.delete_id = "";
          }
        });
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    closeDialog() {
      this.module = {};
      this.deleteDialog = false;
      this.$validator.reset();
      this.serverSideErrors = [];
    },
  },
  mounted() {
    this.getModules();
  },
};
</script>